/**
 * Helper styles that can be used by other components to style them like a button
 *  @example
 * const LooksLikeAButton = styled(SomeComponent)`${buttonCss}`
 */
import { getPaletteText, getDarkPalette } from "../../../../utils/paletteConversions";
export var getDefaultButtonStyles = function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? 'secondary' : _b, _c = _a.emphasis, emphasis = _c === void 0 ? 'high' : _c, theme = _a.theme;
    var text = theme.colors[getPaletteText(palette)];
    var main = theme.colors[palette];
    var dark = theme.colors[getDarkPalette(palette)];
    if (emphasis === 'high') {
        return "\n      color: " + text + ";\n      background-color: " + main + ";\n      border-color: " + main + ";\n      :not([disabled]):hover {\n        background: " + dark + ";\n        border-color: " + dark + ";\n      }\n      :not([disabled]):active {\n        background-color: " + dark + ";\n        background-size: 100%;\n        transition: all 0s;\n      }\n    ";
    }
    if (emphasis === 'medium') {
        return "\n      color: " + dark + ";\n      border: " + theme.borders.regular + ";\n      background-color: transparent;\n      :not([disabled]):hover {\n        color: " + dark + ";\n        border-color: " + dark + ";\n        background: " + theme.colors.opacityLight + ";\n      }\n      :not([disabled]):active {\n        background-color: " + theme.colors.opacity + ";\n        background-size: 100%;\n        transition: all 0s;\n      }\n    ";
    }
    if (emphasis === 'low') {
        return "\n      color: " + dark + ";\n      border-color: transparent;\n      background-color: transparent;\n      :not([disabled]):hover {\n        color: " + main + ";\n        text-decoration: underline;\n      }\n    ";
    }
    return null;
};
//# sourceMappingURL=getDefaultButtonStyles.js.map